<script setup>
import { computed } from 'vue';
import { estiloTagSuave, podeVerApelidoConta } from '@/commons/contaBancaria';

const props = defineProps({
    conta: {
        type: Object,
        default: null
    }
});

const visivel = computed(() => Boolean(props.conta?.apelido) && podeVerApelidoConta());

const estilo = computed(() => estiloTagSuave(props.conta?.cor));
</script>

<template>
    <TagBase v-if="visivel" :valor="props.conta.apelido" :cor="estilo ? null : 'cinza'" :style="estilo" negrito
        classe="w-max flex-shrink-0 font-semibold" />
</template>
